module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAiBAMAAADfS4Y4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURTh2/0dwTDlz/zp2/zx0/zx1/zp2/zxy/zp0/zx0/z52/zp2/z5+/z52/6obm0UAAAANdFJOU4EA+h7nNq9KwZnVZhR2aLb+AAAAyUlEQVQoz2Ow0L2LBi41M+TexQAaDLqYgpcYkDgqdy/5Aom7d5EELxmuVZYCEoQFsWpHAFIEJwqiAUldhkuM6IICQJXUEhTdiEXw0G1UQWGQormqgtKGSIImF4ASuomCvM4IQWFfoKDYpUBB3iuGcEGBu42CgkHXBAUlIDywoKiuuqBgrrKgYBFQNdzMomuCoqBAyFVHskg8UVDi0kGguYWo7qy9gMVHtT5YBEUNyQslzOi4y+CLGW9XGPZiCt5mEGXAAIEMglgAAKoOD46gcwcUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_06_zh.png
// module id = u9um
// module chunks = 34